var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "_900 big",
    attrs: {
      "id": "Client-name"
    }
  }, [_vm._v(" Overenie " + _vm._s(_vm.clientInfo.type.toLowerCase()) + "a ")])]), _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "splitter"
  }, [_vm._v("Vyberte ako chceme " + _vm._s(_vm.clientInfo.type.toLowerCase()) + "a overiť")]), _vm._m(0), _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "8466810e-7557-a963-e1a4-1ff5d954c81e"
    },
    on: {
      "click": function click($event) {
        return _vm.clientVerificationPicker('local');
      }
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("na tomto zariadení")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "8466810e-7557-a963-e1a4-1ff5d954c81e"
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("na diaľku")])]);

}]

export { render, staticRenderFns }